"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var isFlag = function (setName) { return setName === constants_1.flagSet; };
exports.default = isFlag;
